var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro-box"},[(_vm.proInfo !== null)?_c(_vm.componentName,{tag:"component",attrs:{"proInfo":_vm.proInfo}}):_vm._e(),(_vm.proInfo == null)?_c('div',{staticClass:"container empty"},[_c('el-empty',{attrs:{"description":"404，你访问的内容不存在"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }